module.exports = __webpack_public_path__ + "3593fc4ec132b7994f24ed72d5af2e9f.MP3";